import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface NavigationState {
  history: string[];
}

const initialState: NavigationState = {
  history: [],
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    addToHistory: (state, action: PayloadAction<string>) => {
      if (state.history.length === 0) {
        state.history.push(action.payload);
      } else if (
        state.history.length > 0 &&
        state.history[state.history.length - 1] !== action.payload
      ) {
        state.history.push(action.payload);
      }
    },
    goBack: (state) => {
      if (state.history.length > 1) {
        state.history.pop();
      }
    },
  },
});

export const { addToHistory, goBack } = navigationSlice.actions;
export default navigationSlice.reducer;
